/* Circular Fash — lazy background videos.
   Decorative <video data-src> elements download nothing until they are about
   to scroll into view, then load and play muted. Saves ~8 MB on the shop front
   for a phone that never scrolls past the product grid. Honours Save-Data and
   reduced-motion: those visitors keep the poster/background and no video. */
(function () {
  var videos = document.querySelectorAll('video[data-src]');
  if (!videos.length) return;

  var conn = navigator.connection || {};
  var saveData = conn.saveData === true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (saveData || reduced) return;

  function load(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.src = v.dataset.src;
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(load);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        load(e.target);
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '300px 0px' });

  videos.forEach(function (v) { io.observe(v); });

  /* Pause clips that scroll far out of view so a looping video is not
     decoding for nothing. */
  var pauser = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (!v.dataset.loaded) return;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { rootMargin: '100px 0px' });
  videos.forEach(function (v) { pauser.observe(v); });
})();
